<template>
  <div class="dt-page paywall-page">
    <!-- <script src="https://live.adyen.com/hpp/cse/js/1214249872738244.shtml"></script> -->

    <aside class="left-panel">
      <div id="logo">
        <a href="#">
          <img
            class="company-logo"
            :src="`https://detailss3web.s3.amazonaws.com/images/logo/${this.clientName}logo`"
            alt
        /></a>
      </div>
    </aside>
    <div class="main-content center-align">
      <div class="inner-content">
        <template>
          <div class="icon-title">
            <div class="dt-icon-container">
              <img
                src="static/icons/payment-failed.svg"
                class="dt-icon"
                alt="Payment Failed"
                title="Payment Failed"
              />
            </div>
            <span>PAYMENT HAS FAILED!</span>
          </div>
          <p
            class="intro-text"
            style="margin: 8px; margin-top: 16px"
          >
            Unfortunately we are unable to complete the
            processing of your invoice because payment
            authorization to your credit/debit card has failed.
          </p>
          <p class="intro-text" style="margin: 8px">
            This means that your credit/debit card issues has
            declined our request for authorization due to an
            invalid credit/debit card number, incorrect
            expiration date, exceedance of your daily limit
            insufficient funds or perpahs some other reasons.
          </p>
        </template>

        <span class="ut-fb" style="margin: 0px 8px"
          >Invoice Items and Costs</span
        >
        <div class="invoice-items">
          <p
            v-for="(invoiceLine, index) of invoiceLines"
            :key="invoiceLine.description + index"
            :style="{
              color: index == 0 ? `var(--c-error)` : 'inherit',
              margin: index == 0 ? `12px 8px` : `4px 8px`,
            }"
          >
            {{ invoiceLine.description }}
            <b v-if="!isNaN(invoiceLine.amount)"
              >&euro;{{ $dft.curr(invoiceLine.amount) }}</b
            >
          </p>
          <div style="height: 16px"></div>
        </div>
        <div
          v-for="op of options"
          class="radio-item"
          :key="op.value"
        >
          <label class="radio-circle">
            <div
              :class="`radio-label ${
                op.disabled ? 'disabled' : ''
              }`"
              :for="op.value"
            >
              {{ op.text }}
            </div>
            <input
              type="radio"
              :checked="op.value == selected"
              :name="'payment_options'"
              @change="onInputChange(op)"
              :disabled="op.disabled"
            />
            <span class="checkmark"></span>
          </label>
          <div class="lbl-text" v-if="op.value == selected">
            <div v-if="op.value == 1" class="radio-expand">
              We suggest clicking this button ONLY when you know
              that your credit card is available for changes
            </div>
            <div v-if="op.value == 2" class="radio-expand">
              <form ref="paymentForm" id="adyen-encrypted-form">
                <input
                  type="hidden"
                  id="adyen-encrypted-form-expiry-generationtime"
                  :value="new Date().toISOString()"
                  data-encrypted-name="generationtime"
                />
                <input
                  type="hidden"
                  id="adyen-encrypted-data-blob"
                />
                <label for="adyen-encrypted-form-number"
                  ><span>Credit Card Number</span
                  ><input
                    data-encrypted-name="number"
                    id="adyen-encrypted-form-number"
                    type="text"
                  />
                </label>
                <label for="adyen-encrypted-form-holder-name"
                  ><span>Card Holder Name</span
                  ><input
                    type="text"
                    id="adyen-encrypted-form-holder-name"
                    size="20"
                    data-encrypted-name="holderName"
                  />
                </label>
                <label for="adyen-encrypted-form-cvc"
                  ><span>CVC Code</span
                  ><input
                    type="password"
                    id="adyen-encrypted-form-cvc"
                    size="4"
                    maxlength="4"
                    style="flex: 0 0 40px"
                    data-encrypted-name="cvc"
                  />
                </label>
                <label for="adyen-encrypted-form-expiry-month"
                  ><span>Expiry (MM / YYYY)</span>
                  <input
                    type="text"
                    id="adyen-encrypted-form-expiry-month"
                    maxlength="2"
                    size="2"
                    style="flex: 0 0 40px"
                    data-encrypted-name="expiryMonth" />
                  <div class="oblique">/</div>
                  <input
                    type="text"
                    id="adyen-encrypted-form-expiry-year"
                    maxlength="4"
                    size="4"
                    style="flex: 0 0 50px"
                    data-encrypted-name="expiryYear"
                /></label>
                <input
                  class="dt-button v1 s2"
                  type="submit"
                  value="Proceed"
                />
              </form>
            </div>
            <div v-if="op.value == 3" class="radio-expand">
              <form ref="sepaForm" id="sepa-form">
                <label for="iban"
                  ><span>IBAN</span
                  ><input
                    v-model="iban"
                    id="iban"
                    type="text"
                  />
                </label>
                <label for="ownerName"
                  ><span>Account Holder</span
                  ><input
                    v-model="ownerName"
                    id="ownerName"
                    type="text"
                  />
                </label>
                <input
                  class="dt-button v1 s2"
                  type="submit"
                  @click="onSepaSubmit"
                  value="Proceed"
                />
              </form>
            </div>
          </div>
        </div>
        <button
          v-if="selected == 1"
          class="dt-button v1 s2"
          @click="onProceed"
        >
          Proceed
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { NotificationService } from "../../../dt-plugins/notification/notification.service";
import { EventHooks } from "../../../plugins/text-field";
import { AccountService } from "../../../services/account.service";

import { clientName } from "../../../services/http/http-client";
import { wait } from "../../../utility";

// import { uuidv4 } from "../../../utility";

const RADIO_HEIGHT = 18;

export default {
  components: {},
  mixins: [],
  data: function () {
    return {
      clientName: clientName,
      selected: 1,
      options: [
        {
          text: "Try Payment Again",
          value: 1,
          hint:
            "We suggest clicking this button ONLY when you know that your credit card is available for changes:",
          disabled: false,
        },
        {
          text: "Pay Invoice with a new Credit Card",
          value: 2,
          hint: "",
          disabled: false,
        },
        {
          text: "Pay Invoice with SEPA (EU Via Bank Account)",
          value: 3,
          hint: "",
          disabled: false,
        },
      ],
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
      paymentMethod: {},

      key:
        "10001|A6880B635EBC8A222407BC2A7493375AEF544A77DCBD3B3733C85DE8ABD2E9BA244BF97D3F8E4415588D365615298E196A81EC90A508CD14DB3C637AD01122C0357E33E5127B691C7ED2EFBF1C1E9F3E0A356E466D53DF7E41CA46BBF05D6624EDE1AAAD04F04CFA15A2C032D456C5C7E13AC1DC3307F826991561B71C552E653994B76A490E61E38D8B1F8CF86E948C70BE41F1A11DF95C0F479C2C767495C10674D22E44CD40FE07DAC8E8345B56B71A7476AFAB8D6C030B72E2818D916D521F5265B84571D12C78A58B1714DDA156803B5167648762237ED33EED5E07B7FC316A5334998E4339E487EEC149C55D30F889EDC6792BF540EFE120DC0EC72F37",

      paymentForm: null,

      iban: "",
      ownerName: "",
    };
  },
  computed: {
    ...mapGetters(["account", "routeBeforeBlock"]),
    invoiceLines: function () {
      console.log(this.account);
      return this.account?.invoice_lines || [];
    },
  },

  watch: {
    selected: {
      immediate: true,
      handler(to, from) {
        if (to == 2) {
          this.initAdyen();
        }
      },
    },
  },

  // DEMO CARD
  // 4242 4242 4242 4242
  // Augustus Ceaser
  // 123
  // 02-2022

  // 3700 0000 0000 002
  // Augustus Ceaser
  // 03/2030	123

  methods: {
    initAdyen: async function () {
      window.key = this.key;
      await this.loadScripts();
      await wait(2000);

      if (this.selected != 2) {
        return;
      }

      console.log(window.adyen);

      this.paymentForm = this.$refs["paymentForm"];
      if (this.paymentForm.length == 1) {
        this.paymentForm = this.paymentForm[0];
      }

      console.log(this.paymentForm);

      var options = {};

      // Enable basic field validation (default is true)
      // The submit button will be disabled when fields
      // proof to be invalid. The form submission will be
      // prevented as well.
      options.enableValidations = false;

      // Always have the submit button enabled (default is false)
      // Leave the submit button enabled, even in case
      // of validation errors.
      options.submitButtonAlwaysEnabled = true;

      // Ignore non-numeric characters in the card number field (default is true)
      // The payment handling ignores non-numeric characters for the card field.
      // By default non-numeric characters will also be ignored while validating
      // the card number field. This can be disabled for UX reasons.
      // options.numberIgnoreNonNumeric = true,

      // Use a different attribute to identify adyen fields
      // Note that the attributes needs to start with data-.
      options.fieldNameAttribute = "data-encrypted-name";

      // Set a element that should display the card type
      // options.cardTypeElement = document.getElementById('cardType');

      // the form will be encrypted before it is submitted
      // adyen.encrypt.createEncryptedForm( form, key, options);

      // window.adyen.encrypt.createEncryptedForm(this.paymentForm, this.key, options);

      const encryptedBlobFieldName =
        "adyen-encrypted-data-blob";
      options.name = encryptedBlobFieldName;

      options.onsubmit = (e) => {
        if (e.preventDefault) e.preventDefault();

        console.log(
          this.paymentForm,
          this.paymentForm.elements
        );

        var encryptedData = this.paymentForm.elements[
          encryptedBlobFieldName
        ].value;
        console.log(
          encryptedData,
          new FormData(this.paymentForm)
        );

        AccountService.payBillCredit({
          adyenEncryptedData: encryptedData,
        }).then((res) => {
          console.log(res);

          this.handlePaymentReponse(res);
        });

        return false;
      };

      setTimeout(() => {
        console.log(this.paymentForm);
        window.adyen.createEncryptedForm(
          this.paymentForm,
          options
        );
      });
    },
    loadScripts() {
      return new Promise((resolve) => {
        let scriptEl = document.createElement("script");
        scriptEl.src =
          "https://live.adyen.com/hpp/cse/js/1214249872738244.shtml";
        scriptEl.type = "text/javascript";

        // Attach script to head
        document
          .getElementsByTagName("body")[0]
          .appendChild(scriptEl);
        // Wait for tag to load before promise is resolved
        scriptEl.addEventListener("load", () => {
          resolve();
        });
      });
    },
    onInputChange: function (op) {
      this.selected = op.value;
      console.log(op.value, this.selected);
    },
    onTextFieldValueChange: function (name, value) {
      console.log({ name, value });
    },
    onValidation: function (name, value) {
      // this.$set(this.validationResult, name, value);
      // console.log(this.validationResult);
    },
    onProceed: async function () {
      const response = await AccountService.payBill();
      this.handlePaymentReponse(response);
    },
    onSepaSubmit: async function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      }
      console.log({
        ownerName: this.ownerName,
        iban: this.iban,
      });

      const response = await AccountService.payBillSEPA({
        iban: this.iban,
        ownerName: this.ownerName,
      });

      this.handlePaymentReponse(response, {
        paymentTarget: "SEPA Account",
      });
    },
    paymentFailed: function ({
      paymentTarget = "credit/debit card",
    } = {}) {
      NotificationService.showNotification({
        text: `Payment authorization to your ${paymentTarget} has failed`,
        timeout: 3000,
        type: "error",
      });
    },
    handlePaymentReponse: function (
      response,
      { paymentTarget = "credit/debit card" } = {}
    ) {
      console.log(response, response.status);
      if (response?.data?.error) {
        this.paymentFailed({ paymentTarget });
      } else {
        this.paymentSuccesful();
      }
    },
    paymentSuccesful: function () {
      this.$router.push({
        path: this.routeBeforeBlock,
      });
      NotificationService.showNotification({
        text: "Payment Succesful",
        timeout: 3000,
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.paywall-page {
  flex-direction: row;
  .left-panel {
    width: 360px;
    background-color: #464646;
  }
  .main-content {
    -webkit-flex: 1;
    flex: 1;
    .inner-content {
      width: 100%;
      max-width: 480px;
      margin: auto;
    }
  }

  form {
    display: flex;
    flex-direction: column;

    margin-top: 10px;

    label {
      display: flex;

      .oblique {
        /* margin-top: 5px; */
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    label > span {
      display: block;
      width: 130px;
      min-width: 130px;
    }

    input[type="text"],
    input[type="password"] {
      max-width: 200px;

      --fc2-bdc: var(--bc-cblue5);
      --fc2-bc: var(--bc-cblue);
      --fc2-tf-padding: 0px 10px;
      --fc2-tf-padding-focus: 0px 10px;
      --fc2-tf-margin: 3px 5px 3px 5px;
      --fc2-tf-margin-focus: -1px 0px -1px 0px;

      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      border-radius: 4px;
      flex: 1;
      outline: none;
      background-color: var(--fc2-bc);
      color: var(--text-primary);
      border: 1px solid;
      border-color: var(--fc2-bdc);
      resize: none;

      &:active,
      &:focus {
        --fc2-bdc: var(--bc-cblue10);
      }
      &::placeholder {
        color: var(--text-primary);
        opacity: 0.25;
      }
    }

    input.dt-button {
      margin-left: 0px;
    }
  }
}

#logo {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100%;
  a {
    display: block;
    text-decoration: none;
    img {
      display: block;
      width: 100%;
      max-width: 200px;
    }
  }
}
.invoice-items {
  /* margin-top: 70px; */
  margin-bottom: 30px;
  max-height: calc(100vh - 600px);
  overflow: auto;
}
.center-align {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.icon-title {
  color: var(--c-error);
  font-weight: 700;
  display: flex;
  margin: 0px 8px;
  .dt-icon-container {
    height: 20px;
    img {
      margin-right: 4px;
    }
  }
}
.intro-text {
  line-height: 24px;
  margin: 0 0 26px;
}

.radio-item {
  margin: 0 8px 16px;
  .lbl-text {
    margin-top: 10px;

    display: block;
    font-size: 12px;
    line-height: 18px;
    padding-left: 35px;
  }
}

.radio-circle {
  display: block;
  font-size: 12px;
  font-weight: 500;
  padding-left: 35px;
  position: relative;
  cursor: pointer;

  // Hide the browser's default checkbox
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;

    // When the radio button is checked, add a blue background
    &:checked ~ .checkmark {
      background-color: #fff;
      border-color: #242424;
      border-width: 4px;

      // Show the indicator (dot/circle) when checked
      &:after {
        display: block;
      }
    }
  }

  // On mouse-over, add a grey background color
  &:hover {
    input ~ .checkmark {
      //background-color: #ccc;
    }
  }

  // Style the indicator (dot/circle)
  .checkmark {
    margin-top: 0;
    &:after {
      top: 2px;
      left: 2px;
      width: 6px;
      height: 6px;
      background: #464646;
      border-radius: 50%;
    }
  }
}

// Create a custom radio button
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  width: 18px;
  height: 18px;
  background-color: #fff;
  border: 1px solid #b3b3b3;
  border-radius: 50%;

  // Create the indicator (the dot/circle - hidden when not checked)
  &:after {
    content: "";
    display: none;
    position: absolute;
  }
}
</style>
